import * as React from "react";
import { TooltipFloating, TooltipRow } from "./styles";

interface ZoomControlProps {
  zoom: string;
  canIncrease: boolean;
  canDecrease: boolean;
  onIncrease: () => void;
  onDecrease: () => void;
}

export function ZoomControl({
  zoom,
  canIncrease,
  canDecrease,
  onIncrease,
  onDecrease,
}: ZoomControlProps) {
  return (
    <TooltipFloating>
      <TooltipRow>
        <span>Zoom</span>
        <div>
          <button
            disabled={!canIncrease}
            onClick={onIncrease}
            aria-label="Aumentar zoom"
          >
            +
          </button>
          <span>{zoom}</span>
          <button
            disabled={!canDecrease}
            onClick={onDecrease}
            aria-label="Diminuir zoom"
          >
            -
          </button>
        </div>
      </TooltipRow>
    </TooltipFloating>
  );
}
